import { ConfigDataInterface } from './ConfigApiInterface';

export enum Config_RewardsPriceManage_ActionsMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_RewardsPriceManage_Modules_ApiEnum {
    'results' = 'results',
}

export enum Config_RewardsPriceManage_ActionsOther_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_RewardsPriceManage_PageMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export enum Config_RewardsPriceManage_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_RewardsPriceManage_ApiInterface
    extends ConfigDataInterface<
        Config_RewardsPriceManage_Modules_ApiEnum,
        Config_RewardsPriceManage_ActionsMenu_ApiEnum,
        Config_RewardsPriceManage_ActionsOther_ApiEnum,
        Config_RewardsPriceManage_PageMenu_ApiEnum,
        Config_RewardsPriceManage_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
